var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',[_c('div',{staticClass:"application"},[(_vm.initialized)?_c('div',{staticClass:"empty-layout"},[_vm._t("default")],2):_c('div',[_c('c-loading')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }